<template>
  <v-dialog v-model="showDialogOversold" width="400" color="white black--text">
    <v-card>
      <v-card-title class="orange lighten-3">
        <h2 class="text-h4 mt-3 mb-1">
          Items Have Limited Stock or Sold Out
        </h2>
      </v-card-title>

      <v-card-text class="pt-6 pb-8">
        <h3 class="text-h5">
          Your cart has been updated because there wasn't enough of the
          following items available:
        </h3>
        <v-divider class="mt-4 mb-2" />
        <div class="text-h6">
          <div v-for="cartItem of getOversoldItems" :key="cartItem.id">
            <v-row no-gutters>
              <v-col cols="auto" class="font-weight-bold">{{
                cartItem.item.name
              }}</v-col>
              <v-spacer />
              <v-col cols="auto" v-if="Number(cartItem.item.stock) > 0"
                >Only {{ cartItem.item.stock }} left</v-col
              >
              <v-col cols="auto" v-else class="font-italic">Sold Out</v-col>
            </v-row>
            <v-divider class="my-2" />
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="showDialogOversold = false"
          outlined
          color="grey darken-3"
          >Ok, Show My Cart</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'DialogOversold',
  components: {},
  computed: {
    ...mapFields('cart', ['showDialogOversold']),
    ...mapGetters('cart', ['getOversoldItems']),
  },
  methods: {},
  data() {
    return {}
  },
}
</script>
